// 后端接口文件
import request from '@/utils/request'

//登录
export function login(data) {
    return request({
        url: '/api/oauth2/token',
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' },
        data
    })
}
//注册
export function register(data) {
    return request({
        url: '/api/oauth2/register',
        method: 'post',
        data
    })
}
//找回账号
export function findusername(data) {
    return request({
        url: '/api/oauth2/findusername',
        method: 'get',
        params:data
    })
}
//找回密码
export function findpassword(data) {
    return request({
        url: '/api/oauth2/findpassword',
        method: 'post',
        params:data
    })
}


//退出登录
export function logout(data) {
    return request({
        url: '/api/oauth2/logout',
        method: 'post',
        data
    })
}

//修改密码
export function oauthChangepassword(data) {
    return request({
        url: '/api/oauth2/changepassword',
        method: 'post',
        params:data
    })
}
